(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-brand-film')) {
    customElements.define('maison-brand-film', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const video = this.querySelector('video');
        const media = this.querySelector('.mx-film__media');
        const toggle = this.querySelector('[data-film-toggle]');
        const label = this.querySelector('[data-film-label]');
        if (!video || !toggle) return;
        this.video = video;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const saveData = Boolean(navigator.connection && navigator.connection.saveData);
        let userPaused = this.dataset.autoplay !== 'true' || reducedMotion.matches || saveData;
        let inView = false;
        let sourceAttached = false;
        let sourceCandidates = null;
        const ensureSource = () => {
          if (sourceAttached) return true;
          if (sourceCandidates === null) {
            const nativeHls = video.dataset.srcHls && video.canPlayType('application/vnd.apple.mpegurl');
            const width = window.innerWidth;
            const progressiveSources = width <= 749
              ? [video.dataset.srcMobile, video.dataset.srcTablet, video.dataset.srcDesktop]
              : width <= 1199
                ? [video.dataset.srcTablet, video.dataset.srcDesktop, video.dataset.srcMobile]
                : [video.dataset.srcDesktop, video.dataset.srcTablet, video.dataset.srcMobile];
            sourceCandidates = [...new Set([...(nativeHls ? [video.dataset.srcHls] : []), ...progressiveSources, video.dataset.srcFallback].filter(Boolean))];
          }
          const source = sourceCandidates.shift();
          if (!source) { this.dataset.videoError = 'true'; return false; }
          delete this.dataset.videoError;
          media?.classList.remove('is-loaded');
          sourceAttached = true;
          video.src = source;
          video.load();
          return true;
        };
        const update = () => {
          const playing = !video.paused && !video.ended;
          toggle.dataset.playing = String(playing);
          toggle.setAttribute('aria-label', playing ? this.dataset.pauseAria : this.dataset.playAria);
          if (label) label.textContent = playing ? this.dataset.pause : this.dataset.play;
        };
        const playWhenAllowed = () => {
          if (!userPaused && inView && !document.hidden && ensureSource()) video.play().then(update).catch(update);
          else { video.pause(); update(); }
        };
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('play', update, { signal });
        video.addEventListener('pause', update, { signal });
        video.addEventListener('ended', update, { signal });
        video.addEventListener('loadeddata', () => media?.classList.add('is-loaded'), { signal });
        video.addEventListener('error', () => {
          sourceAttached = false;
          media?.classList.remove('is-loaded');
          if (ensureSource()) playWhenAllowed();
          else { video.pause(); update(); }
        }, { signal });
        toggle.addEventListener('click', () => {
          if (video.paused) {
            userPaused = false;
            if (this.dataset.videoError === 'true') sourceCandidates = null;
            if (ensureSource()) video.play().then(update).catch(update);
          } else { userPaused = true; video.pause(); }
        }, { signal });
        document.addEventListener('visibilitychange', playWhenAllowed, { signal });
        reducedMotion.addEventListener('change', () => {
          if (reducedMotion.matches) { userPaused = true; video.pause(); update(); }
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            inView = entry.isIntersecting && entry.intersectionRatio > .35;
            playWhenAllowed();
          }, { threshold: [0, .35, .75] });
          this.observer.observe(media || this);
        } else { inView = true; playWhenAllowed(); }
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-formats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-format-selector')) {
    customElements.define('maison-format-selector', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.querySelector('[data-format-dialog]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.dialog = dialog;
        const title = dialog.querySelector('[data-format-title]');
        const panels = Array.from(dialog.querySelectorAll('[data-format-panel]'));
        this.querySelectorAll('[data-format-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            const panel = panels.find((item) => item.dataset.formatPanel === trigger.dataset.formatTrigger);
            if (!panel || !panel.querySelector('a')) return;
            event.preventDefault();
            panels.forEach((item) => { item.hidden = item !== panel; });
            title.textContent = trigger.dataset.dialogTitle;
            this.lastTrigger = trigger;
            dialog.showModal();
            dialog.querySelector('[data-format-close]')?.focus();
          }, { signal });
        });
        dialog.querySelector('[data-format-close]')?.addEventListener('click', () => dialog.close(), { signal });
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }, { signal });
        dialog.addEventListener('close', () => this.lastTrigger?.focus(), { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-editable-carousel')) {
    customElements.define('maison-editable-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.current = Math.max(0, this.slides.findIndex(slide => slide.hasAttribute('data-active')));
        this.pauseButton = this.querySelector('[data-pause]');
        this.status = this.querySelector('[data-status]');
        this.delay = Number(this.dataset.delay) || 5000;
        this.userPaused = false;
        this.editorPaused = false;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.goTo(this.current - 1, true), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.current + 1, true), options);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot), true), options));
        this.pauseButton?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.updatePause(); this.schedule(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.editorPaused = true;
          this.goTo(index, false);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;
          this.editorPaused = false;
          this.schedule();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting && entry.intersectionRatio > .35; this.schedule(); }, { threshold: [0, .35, .65] });
          this.observer.observe(this);
        }
        this.goTo(this.current, false);
        this.updatePause();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
      schedule() {
        clearTimeout(this.timer);
        if (this.slides.length > 1 && this.dataset.autoplay === 'true' && !this.userPaused && !this.editorPaused && !this.hovered && !this.focused && this.visible && !document.hidden && !this.motion.matches && !navigator.connection?.saveData) this.timer = setTimeout(() => this.goTo(this.current + 1, false), this.delay);
      }
      goTo(index, announce) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { const active = i === this.current; slide.toggleAttribute('data-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
        this.dots.forEach((dot, i) => { if (i === this.current) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        if (announce && this.status) this.status.textContent = this.dataset.statusTemplate.replace('__index__', this.current + 1).replace('__length__', this.slides.length);
        this.schedule();
      }
      updatePause() { if (this.pauseButton) { this.pauseButton.dataset.paused = String(this.userPaused); this.pauseButton.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel); } }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
